import { render } from "./ProductTypeForm.vue?vue&type=template&id=6701823c&ts=true"
import script from "./ProductTypeForm.vue?vue&type=script&lang=ts"
export * from "./ProductTypeForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__